import type { SVGProps } from "react";
export interface FenceIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FenceIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FenceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m4 14.876.115.005a1.125 1.125 0 0 1 0 2.239L4 17.125H2a1.125 1.125 0 0 1 0-2.25zm10 0a1.125 1.125 0 0 1 0 2.25h-4a1.126 1.126 0 0 1 0-2.25zm8 0 .115.005a1.125 1.125 0 0 1 0 2.239l-.115.005h-2a1.125 1.125 0 0 1 0-2.25zM18.375 16a1.375 1.375 0 0 1-2.743.141l-.008-.14.008-.141A1.375 1.375 0 0 1 17 14.625l.14.007c.694.07 1.235.657 1.235 1.368M4 8.875a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 0 1 0-2.25zm10 0 .116.006a1.125 1.125 0 0 1 0 2.239l-.116.006h-4a1.126 1.126 0 0 1 0-2.25h4Zm8 0 .115.006a1.125 1.125 0 0 1 0 2.239l-.115.006h-2a1.125 1.125 0 0 1 0-2.25h2Zm-3.625 1.126a1.375 1.375 0 0 1-2.743.14l-.008-.14.008-.141A1.375 1.375 0 0 1 17 8.625l.14.007c.694.07 1.235.657 1.235 1.369m-10 6a1.375 1.375 0 0 1-2.742.14l-.008-.14.008-.141A1.374 1.374 0 0 1 7 14.625l.14.007c.694.07 1.235.656 1.235 1.368Zm0-6a1.375 1.375 0 0 1-2.742.14l-.008-.14.008-.141A1.375 1.375 0 0 1 7 8.625l.14.007c.694.07 1.235.656 1.235 1.369"
      />
      <path
        fill={color}
        d="M15.126 6.857v13.018h3.75V6.86l-1.877-2.645zm-10.001 0v13.018h3.75V6.857L7 4.214zm6 13.143A2.126 2.126 0 0 1 9 22.125H5A2.126 2.126 0 0 1 2.875 20V6.819c0-.44.137-.87.391-1.229l2.001-2.821.169-.21a2.127 2.127 0 0 1 3.128 0l.169.21 2 2.821c.255.36.392.789.392 1.229v13.18Zm10 0A2.126 2.126 0 0 1 19 22.125h-4A2.125 2.125 0 0 1 12.875 20V6.819c0-.44.136-.87.39-1.229l2-2.821.17-.21a2.126 2.126 0 0 1 3.128 0l.17.21 1.999 2.821.09.138c.197.328.302.706.302 1.091v13.18Z"
      />
    </svg>
  );
}
